/**
 * 作用域标签（**N 域设置页专属** · `DR-020` §B 层级标注铁律）
 *
 * 🔴 **每个设置项必须显式标注作用域**（**账本级** / **用户级**），同页并存时以**分组标题**区分 ——
 * 防"个人主题改了以为全家变了"。
 *
 * ⚠️ 抽成独立组件的原因：设置页与「提醒偏好面板」都要用它 ⇒ 定义在 `SettingsPage.tsx` 里会让
 * 面板反向 import 页面（循环依赖）。**一处定义、两处引用**（铁律 24）。
 *
 * 🔴 两个作用域必须**视觉可分**：账本级走 `primary`（填充感更强），用户级走 `default`。
 */

import { Chip } from '@mui/material';

export type Scope = '账本级' | '用户级';

/** 作用域中文名（🔴 唯一源 —— 别处要显示作用域请引用它） */
export const SCOPE_LABELS: readonly Scope[] = ['账本级', '用户级'];

export function ScopeTag({ scope }: { scope: Scope }) {
  return (
    <Chip
      size="small"
      variant="outlined"
      label={scope}
      color={scope === '账本级' ? 'primary' : 'default'}
      data-testid={`scope-${scope === '账本级' ? 'ledger' : 'user'}`}
    />
  );
}
